import { lazy } from "react";
import IRoute from "./IRoute";

const ViewBookmakers = lazy(() => import("../pages/Bookmakers/ViewBookmakers"));

const bookmakersRoute: IRoute = {
  path: "/bookmakers",
  redirect: "/bookmakers/view",
  children: [
    {
      path: "/view",
      component: ViewBookmakers,
      needAuth: true,
    },
  ],
};

export default bookmakersRoute;
